// extracted by mini-css-extract-plugin
export default {"navigation":"side-navigation_navigation__93Y1K","toggleButton":"side-navigation_toggleButton__6VJS9"};